var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    {
      key: _vm.postData.id,
      staticClass: "preview",
      class: _vm.postData.release_type,
    },
    [
      _c(
        "d-main-image",
        _vm._b(
          { on: { load: _vm.pageLoaded } },
          "d-main-image",
          { img: _vm.img, show: _vm.show },
          false
        )
      ),
      _c("k-hero"),
      _c("w-go-down"),
      _c(
        "k-main",
        { attrs: { title: _vm.title } },
        [
          _c("media-info-icons", { attrs: { post: _vm.postData } }),
          _c("section", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
          _vm.postData.full_content &&
          _vm.canWatchNow(_vm.postData.full_content)
            ? _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    variant: "primary",
                    to: _vm.postData.full_content.path,
                    size: "lg",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.sayAction(_vm.postData.full_content)) + " now"
                  ),
                ]
              )
            : _c(
                "section",
                { staticClass: "subscriptions" },
                [
                  _c(
                    "subscription-menu",
                    { attrs: { target: _vm.postData.path } },
                    [
                      _vm._v(
                        "Select one of the subscription plans to see the full content."
                      ),
                    ]
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c("div", { staticClass: "bottom-spacer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }